var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 0.333333C7.33333 0.149333 7.18333 0 7 0H5.33333C3.492 0 2 1.34333 2 3V4.8H0.333333C0.149333 4.8 0 4.94933 0 5.13333V6.86667C0 7.05067 0.149333 7.2 0.333333 7.2H2V11.6667C2 11.8507 2.14933 12 2.33333 12H4.33333C4.51667 12 4.66667 11.8507 4.66667 11.6667V7.2H6.41267C6.56267 7.2 6.694 7.1 6.73467 6.956L7.21533 5.22267C7.27467 5.01067 7.11467 4.8 6.89467 4.8H4.66667V3C4.66667 2.66867 4.96467 2.4 5.33333 2.4H7C7.18333 2.4 7.33333 2.25067 7.33333 2.06667V0.333333Z",
    fill: "#535861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fbIcon.fdb0a43cb5f1e5420ca945fea0cbaf50.svg";
export { ForwardRef as ReactComponent };